import { Typography } from '~/components';
import { Icon, getTheme, pxToRem, styled } from '~/modules';

const textMain = getTheme('text.main');
const textLink = getTheme('text.link');
const smSpacing = getTheme('spacing.sm');
const mdSpacing = getTheme('spacing.md');

export const StepsTitle = styled(Typography).attrs({
  variant: 'md',
})`
  font-weight: 600;
`;

export const StepsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${mdSpacing}px;
`;

export const StepsItem = styled.div`
  display: grid;
  grid-template-columns: 21px 1fr;
  align-items: center;
  gap: ${smSpacing}px;
`;

export const StepsItemIcon = styled(Icon).attrs({
  fontSize: pxToRem(16),
})`
  color: ${textLink};
  justify-self: center;
`;

export const StepsItemDescription = styled(Typography).attrs({
  variant: 'md',
})`
  color: ${textMain};
  text-align: left;
`;
